import React from 'react';
import { Money } from 'shared/types/product/Money';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import useLocale from 'helpers/hooks/useLocale';
import { getCurrencyCookie } from 'helpers/utils/getCurrencyCookie';

interface Props {
  isSearchSuggestion?: boolean;
  discountedPrice?: Money;
  price?: number;
  className?: string;
  discountedPercentage?: number;
  mrrpPrice?: number | null;
}

const PriceMap: React.FC<Props> = ({
  isSearchSuggestion,
  price,
  discountedPrice,
  discountedPercentage,
  mrrpPrice,
  className = '',
}) => {
  const { ctLocale: locale } = useLocale();
  if (price === undefined) return null;

  const localeSelection = getCurrencyCookie('locale_selection');
  const currency: string = localeSelection?.currency || null;

  const displayPrice = price === null ? 0 : price;

  return (
    <>
      {isSearchSuggestion ? (
        <div className="flex flex-col items-center gap-y-2">
          <p className={`pr-3 text-sm font-normal`}>
            {currency === 'GBP' ? '£' : '€'}
            {(displayPrice / 100).toFixed(2)}
          </p>
        </div>
      ) : (
        <div>
          {typeof discountedPercentage === 'number' && discountedPercentage > 0 ? (
            <div className="flex flex-col items-center gap-y-2">
              <p className="font-body text-14 font-normal leading-[14px] text-[#4B4B4B] line-through">
                MRRP {currency === 'GBP' ? '£' : '€'}
                {((mrrpPrice ?? 0) / 100).toFixed(2)}
              </p>
              <p className={`font-body text-[28px] font-bold leading-8 text-primary-black sm:text-[32px] ${className}`}>
                {currency === 'GBP' ? '£' : '€'}
                {(displayPrice / 100).toFixed(2)}
              </p>
            </div>
          ) : (
            <p className={`font-body text-[28px] font-bold leading-8 text-primary-black sm:text-[32px] ${className}`}>
              {currency === 'GBP' ? '£' : '€'}
              {(displayPrice / 100).toFixed(2)}
            </p>
          )}
        </div>
      )}
    </>
  );
};

export default PriceMap;
